import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContainerContent from '../../components/ContainerContent';

import Interpretations from '../interpretations/Interpretations';

import { useReport } from './hooks/useReport';
import {
  getFilteredIndicators,
  getSubjectFromReportData,
  sortIndicatorsByPriority
} from './utils';

import {
  Background,
  ErrorText,
  LoadingText,
  ReportContainer,
} from './styles';

const Report: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsOpenModal] = useState(false);
  const { reportData, loading, error } = useReport();

  const handleModalOpen = () => setIsOpenModal(true);

  const subject = getSubjectFromReportData(reportData);
  const indicators = getFilteredIndicators(reportData);
  const sortedIndicators = sortIndicatorsByPriority(indicators);

  if (loading) {
    return (
      <ContainerContent>
        <ReportContainer>
          <LoadingText>{t('generatingHealthReport')}</LoadingText>
        </ReportContainer>
      </ContainerContent>
    );
  }

  if (error) {
    return (
      <ContainerContent>
        <ErrorText>{error}</ErrorText>
      </ContainerContent>
    );
  }

  if (!subject) {
    return (
      <ContainerContent>
        <ErrorText>No subject data available</ErrorText>
      </ContainerContent>
    );
  }

  return (
    <ContainerContent>
      <Background>
        <Interpretations info={reportData?.info} />
      </Background>
    </ContainerContent>
  );
};

export default Report;